import { Typography } from '@mui/material';

import { BouncingLoader } from './walletItem';

const BouncingLoaderComp = () => {
	return (
		<BouncingLoader component="div">
			<Typography component="div"></Typography>
			<Typography component="div"></Typography>
			<Typography component="div"></Typography>
		</BouncingLoader>
	);
};

export default BouncingLoaderComp;
